/* Lazy video loading: videos use preload="none" and only load/play near the viewport. */
(function () {
  var proto = window.HTMLMediaElement && HTMLMediaElement.prototype;
  if (!proto) return;
  var origPlay = proto.play;
  /* Page scripts call play() on every <video> at start-up; hold those back until the video is near the viewport. */
  proto.play = function () {
    if (this.tagName === 'VIDEO' && this.getAttribute('preload') === 'none' && !this.__lzOn) {
      return Promise.resolve();
    }
    return origPlay.apply(this, arguments);
  };
  function start(v) {
    v.__lzOn = true;
    try { v.muted = true; v.preload = 'auto'; } catch (e) {}
    var p = origPlay.call(v);
    if (p && p.catch) p.catch(function () {});
  }
  function stop(v) {
    try { v.pause(); } catch (e) {}
  }
  if (!('IntersectionObserver' in window)) {
    window.addEventListener('load', function () {
      document.querySelectorAll('video[preload="none"]').forEach(start);
    });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) start(en.target); else if (en.target.__lzOn) stop(en.target);
    });
  }, { rootMargin: '300px 300px 300px 300px' });
  var seen = new WeakSet();
  function watch(v) {
    if (seen.has(v) || v.tagName !== 'VIDEO') return;
    seen.add(v);
    io.observe(v);
  }
  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.tagName === 'VIDEO') watch(root);
    else if (root.querySelectorAll) root.querySelectorAll('video').forEach(watch);
  }
  scan(document.documentElement);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(scan); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
